module.exports = __webpack_public_path__ + "static/media/back-side.efbe8169.png";